import React, { useState } from "react";
import InputFieldsEmailTextPassword from "../common/InputFieldsEmailTextPassword";
import Select from "react-select";
import ButtonCommonComponent from "../common/ButtonCommonComponent";
import TextAreaField from "../common/TextAreaField";
// import LinkBorderCommonButton from "../common/LinkBorderCommonButton";
// import { superAdminDashboard } from "../common/allLinks";

const teamSizeOptions = [
  { value: "10-50", label: "10-50" },
  { value: "51-100", label: "51-100" },
];
const yearlyRevenueOptions = [{ value: "Range", label: "Range" }];

export default function AddNewClientDetailsTabPanel({ handleOnSelect }) {
  const [values, setValues] = useState({
    clientName: "",
    aboutClient: "",
    teamSize: "",
    yearlyRevenue: "",
    typeOfIndustry: "",
    companyWebsite: "",
  });

  /*===========================================
                handleOnChange
===========================================*/
  const handleOnChange = (e) => {
    setValues({
      ...values,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeTeamSize = (selectedOption) => {
    setValues({ ...values, teamSize: selectedOption });
  };

  const handleChangeYearlyRevenue = (selectedOption) => {
    setValues({ ...values, yearlyRevenue: selectedOption });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // console.log(values);
    handleOnSelect(1);
  };

  /**==========================================================================  
                return
  ============================================================================ */
  return (
    <div className="client-dashboard-add-new-requirement-project-detaild-main-div">
      <div className="row mx-0 align-items-start flex-nowrap">
        <div className="col-6 ">
          <InputFieldsEmailTextPassword
            type="text"
            name="clientName"
            value={values.clientName}
            placeholder="For ex: TechM"
            onChange={handleOnChange}
            label="Client Name"
          />
          <TextAreaField
            containerClassName="mt-20 myrl-input-div--textareaSaClient"
            label="About Client"
            placeholder="For ex, Additional Details"
            onChange={handleOnChange}
            name="aboutClient"
            value={values.aboutClient}
          />
        </div>
        <div className="col-6">
          <>
            <p className="font-14-NunitoSans-600 mt-agency-dashboard-label">
              Team Size
            </p>
            <div className="react-select-client-dashboard-add-new-requirement">
              <Select
                className="react-select-container react-select-container--client-dashboard-add-new-requirement"
                classNamePrefix="react-select-elements"
                isSearchable={false}
                options={teamSizeOptions}
                value={values.teamSize}
                onChange={handleChangeTeamSize}
                placeholder="10-50"
              />
            </div>
          </>
          <>
            <p className="font-14-NunitoSans-600 mt-agency-dashboard-label pt-25">
              Yearly Revenue
            </p>
            <div className="react-select-client-dashboard-add-new-requirement">
              <Select
                className="react-select-container react-select-container--client-dashboard-add-new-requirement"
                classNamePrefix="react-select-elements"
                isSearchable={false}
                options={yearlyRevenueOptions}
                value={values.yearlyRevenue}
                onChange={handleChangeYearlyRevenue}
                placeholder="Range"
              />
            </div>
          </>
          <div className="pt-25">
            <InputFieldsEmailTextPassword
              type="text"
              name="typeOfIndustry"
              value={values.typeOfIndustry}
              placeholder="IT Services"
              onChange={handleOnChange}
              label="Type of Industry"
            />
          </div>
          <InputFieldsEmailTextPassword
            type="text"
            name="companyWebsite"
            value={values.companyWebsite}
            placeholder="Www.Company Website.com"
            onChange={handleOnChange}
            label="Company Website"
          />
        </div>
      </div>

      <div className="text-center mt-50">
        {/* <LinkBorderCommonButton
          linkPath={superAdminDashboard}
          linkText="Save &amp; Exit"
          extraClassName="mr-30"
        /> */}
        <ButtonCommonComponent text="Save &amp; Next" onClick={handleSubmit} />
      </div>
    </div>
  );
}
